var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.553,
    height: 15.903,
    viewBox: "0 0 12.553 15.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Company_Name",
    "data-name": "Company Name",
    d: "M211.773,163.052v1.921l5.171,3.221V174.5H204.39V158.6Zm.66,5.089h1V169h-1Zm1.915,3.6h1v.859h-1Zm-1.915,0h1v.859h-1Zm1.915-1.9h1v.86h-1Zm-1.915,0h1v.86h-1Zm-2.973,1.9h1v.859h-1Zm-1.916,0h1v.859h-1Zm-1.916,0h1v.859h-1Zm3.831-1.9h1v.86h-1Zm-1.916,0h1v.86h-1Zm-1.916,0h1v.86h-1Zm3.831-1.889h1v.859h-1Zm-1.916,0h1v.859h-1Zm-1.916,0h1v.859h-1Zm3.831-1.9h1v.86h-1Zm-1.916,0h1v.86h-1Zm-1.916,0h1v.86h-1Zm3.831-1.9h1v.859h-1Zm-1.916,0h1v.859h-1Zm-1.916,0h1v.859h-1ZM211.773,166v7.635h4.3v-4.957Zm-.872,7.635q0-5.044,0-10.09l-5.64-3.4v13.49H210.9Z",
    transform: "translate(-204.39 -158.601)",
    fill: "#ff7200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.70d216703cdaf1bfbedfcefa196fa124.svg";
export { ForwardRef as ReactComponent };